import { render, staticRenderFns } from "./DownloadSuccessful.vue?vue&type=template&id=53b9185e&scoped=true"
import script from "./DownloadSuccessful.vue?vue&type=script&lang=js"
export * from "./DownloadSuccessful.vue?vue&type=script&lang=js"
import style0 from "./DownloadSuccessful.vue?vue&type=style&index=0&id=53b9185e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b9185e",
  null
  
)

export default component.exports